const API_URL = '/api/teachers';

export interface HorarioRango {
  inicio: string;
  fin: string;
}

export interface TiemposDisponibles {
  lunes: HorarioRango[];
  martes: HorarioRango[];
  miercoles: HorarioRango[];
  jueves: HorarioRango[];
  viernes: HorarioRango[];
  sabado: HorarioRango[];
  domingo: HorarioRango[];
}

export interface Teacher {
  id: number;
  userId?: number | null;
  nombre: string;
  telefono?: string | null;
  contactoEmergencia?: string | null;
  domicilio?: string | null;
  tiemposDisponibles?: TiemposDisponibles | null;
  aperturacierre?: boolean;
  maximoClases?: number;
  tipoContrato?: string;
  createdAt: string;
  updatedAt: string;
  userName?: string | null;
  userEmail?: string | null;
  courses?: Course[];
}

export interface Course {
  id: number;
  code: string;
  name: string;
}

export interface TeacherInput {
  userId?: number | null;
  nombre: string;
  telefono?: string | null;
  contactoEmergencia?: string | null;
  domicilio?: string | null;
  tiemposDisponibles?: TiemposDisponibles | null;
  aperturacierre?: boolean;
  maximoClases?: number;
  tipoContrato?: string;
}

export interface TeacherCoursesInput {
  courseIds: number[];
}

export async function getTeachers(): Promise<Teacher[]> {
  const response = await fetch(API_URL, {
    credentials: 'include',
  });
  if (!response.ok) {
    throw new Error('Error al obtener profesores');
  }
  return response.json();
}

export async function getTeacher(id: number): Promise<Teacher> {
  const response = await fetch(`${API_URL}/${id}`, {
    credentials: 'include',
  });
  if (!response.ok) {
    throw new Error('Error al obtener profesor');
  }
  return response.json();
}

export async function createTeacher(data: TeacherInput): Promise<Teacher> {
  const response = await fetch(API_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    const error = await response.json();
    throw { response: { data: error } };
  }
  return response.json();
}

export async function updateTeacher(id: number, data: TeacherInput): Promise<Teacher> {
  const response = await fetch(`${API_URL}/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    const error = await response.json();
    throw { response: { data: error } };
  }
  return response.json();
}

export async function deleteTeacher(id: number): Promise<void> {
  const response = await fetch(`${API_URL}/${id}`, {
    method: 'DELETE',
    credentials: 'include',
  });
  if (!response.ok) {
    const error = await response.json();
    throw { response: { data: error } };
  }
}

export async function updateTeacherCourses(
  id: number,
  data: TeacherCoursesInput
): Promise<Course[]> {
  const response = await fetch(`${API_URL}/${id}/courses`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    const error = await response.json();
    throw { response: { data: error } };
  }
  return response.json();
}
